module.exports = __webpack_public_path__ + "static/media/logo.ff9a163f.svg";